/**
 * RISKS-SCALES.ROUTES
 * Define scales for the accountRisksSettings
 */
import NavApp, { scalesNavItem } from "@/nav/nav.app"
import PageHeader from "@/components/page-header"
import RiskScales from "@/entities/physical-risk/ui/RiskScales"

export default function RisksScalesRoute() {
  return (
    <NavApp>
      <PageHeader
        title={scalesNavItem.text}
        subtitle="Définissez les échelles, les familles de risques et les enquêtes de votre compte."
      />
      <RiskScales />
    </NavApp>
  )
}
